export enum FaceType {
    Node = "Node",
    Hole = "Hole",
    Plane = "Plane",
    HalfPlane = "HalfPlane",
    Curved = "Curved",
}

export enum Face {
    Right = "Right",
    Left = "Left",
    Top = "Top",
    Bottom = "Bottom",
    Front = "Front",
    Back = "Back",
}

export const MaterialName = ["Top", "Bottom", "Front", "Right", "Back", "Left", "Curved"];

export interface CountInputData {
    name: string;
    facePattern: string;
    color: object;
    connectionData: ConnectionData[];
    uuid: string[];
}

export interface CountOutputData {
    name: string;
    facePattern: string;
    color: object;
    count: number;
    connectionData: ConnectionData[];
    uuid: string[];
}

export interface ConnectionData {
    face: string;
    connectionType: string;
}

export interface InputObject {
    [key: string]: string | undefined;
}

export interface OutputObject {
    Top: string;
    Bottom: string;
    Right: string;
    Left: string;
    Front: string;
    Back: string;
}
